<div class="flex flex-col items-center justify-center w-full px-2 pt-4 space-y-4">
  @if (config.selectMultiple) {
    <div class="flex items-center w-full" [ngClass]="{
      'justify-between ': isItemSelectionActive,
      'justify-end ': !isItemSelectionActive,
    }">
      @if (isItemSelectionActive) {
        <div class="flex items-center justify-center -translate-x-4">
          <nrc-checkbox
            [checkStatus]="isEveryPageItemSelectedSig() ? 'checked' : (isSomeButNotEveryPageItemSelectedSig() ? 'semi-checked' : 'unchecked')"
            (clickEvent)="toggleAllItemsIsSelected()"
          />

          <span class="text-sm text-white -translate-x-2">All</span>
        </div>
      }

      <nrc-button
        [label]="isItemSelectionActive ? 'Deselect files' : 'Select files'"
        [icon]="isItemSelectionActive ? 'multi-check-off' : 'multi-check'"
        [role]="actionRole.SECONDARY"
        (clickEvent)="toggleItemSelection()"
      />
    </div>
  }

  <div class="@container w-full h-full">
    <div class="grid w-full h-full grid-cols-2 @3xl:grid-cols-4 @7xl:grid-cols-6 gap-4 md:gap-6">
      @for (item of items(); track i; let i = $index) {
        <div class="flex justify-center w-full" attr.id="grid-item-{{i}}">
          @for (column of config.columns; track $index) {
            <div
              class="w-full cursor-pointer"
              tabindex="0"
              (keydown)="null"
            >
              @if (!column['visibilityFn'] || column['visibilityFn'](item.value | extractProperty: column.key)) {
                <nrc-grid-list-item
                  class="flex flex-col items-center justify-between w-full"
                  [ngClass]="{
                    'justify-start': !column.align || column.align === 'left',
                    'justify-center mr-13': column.align === 'center',
                    'justify-end': column.align === 'right'
                  }"
                  [index]="i"
                  [isSelected]="item.isSelected"
                  [config]="{
                      type: column.type,
                      value: item.value | extractProperty: column.key,
                      originalValue: item.value,
                      additionalInfo: column.additionalInfoKeys ? (item.value | extractProperties: column.additionalInfoKeys | join: ' | ') : undefined,
                      thumbnailConfig: column.thumbnailConfig,
                      mimetype: column.thumbnailConfig && column.thumbnailConfig.thumbnailSourceKey && (item.value | extractProperty: (column.thumbnailConfig.thumbnailSourceKey | toString) | toString)
                        ? 'image/png'
                        : (item.value | extractProperty: (column.thumbnailConfig?.fallbackMimetypeKey | toString) | toString),
                      mediaSource: column.thumbnailConfig && column.thumbnailConfig.mediaSourceKey
                        ? (item.value | extractProperty: (column.thumbnailConfig.mediaSourceKey | toString) | toString)
                        : undefined,
                      thumbnailSource: column.thumbnailConfig && column.thumbnailConfig.thumbnailSourceKey
                        ? (item.value | extractProperty: (column.thumbnailConfig.thumbnailSourceKey | toString) | toString)
                          ? (item.value | extractProperty: (column.thumbnailConfig.thumbnailSourceKey | toString) | toString)
                          : (item.value | extractProperty: (column.thumbnailConfig.fallbackThumbnailSourceKey | toString) | toString)
                        : undefined,
                      isHighlighted: column.isHighlighted,
                      showTooltip: column.showTooltip,
                      actionRole: item.actionRole,
                      buttonConfigs: column['buttonConfigs'],
                      extractorFn: column['extractorFn'],
                      tooltipTextFn: column['tooltipTextFn'],
                      itemActionButtons: config.itemActionButtons
                  }"
                  [showCheckbox]="isItemSelectionActive"
                  [showContextMenu]="!isItemSelectionActive"
                  (configButtonClickEvent)="this.configButtonClickEvent.emit({ index: i, key: $event.key });"
                  (itemActionButtonEvent)="handleItemAction($event)"
                  (itemClickEvent)="handleGridItemClickedEvent(item, i)"
                />
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

